export const copyStringToClipboard = str => {
  try {
    navigator.clipboard.writeText(str);
  } catch {
    try {
      const el = document.createElement('textarea');
      el.value = str;
      el.setAttribute('readonly', '');
      el.style.display = 'hidden';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    } catch {}
  }
};